/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, ReactNode, useEffect, useState } from "react";

import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";

import { allergiesMap } from "@/utils/mappings/allergies";
import { transformData } from "@/utils/transformData";
import { usePatient } from "@/hooks/usePatient";
import { useApi } from "@/hooks/useApi";

type CardPatientProps = {
	title: string;
	children: ReactNode;
};

export function PatientInformationCards() {
	const [allergies, setAllergies] = useState<Allergies[]>([]);
	const { patient } = usePatient();
	const { api } = useApi();

	const CardPatient = ({ title, children }: CardPatientProps) => (
		<Col md={12} className="m-0 mb-6">
			<Card className="d-flex h-100">
				<div className="p-6 h-100">
					<Card.Title className="fs-5">{title}</Card.Title>
					<div className="flex-wrap text-gray-700 mt-6 mb-6">{children}</div>
				</div>
			</Card>
		</Col>
	);

	async function patientAllergies(patientId: number) {
		try {
			const { data } = await api.get("patients/allergies", {
				params: { patientId },
			});

			const transformedData = transformData<Allergies[]>(data, allergiesMap);

			setAllergies(transformedData);
		} catch (error) {
			console.log(error);
		}
	}

	const evolutionMock = [
		{
			id: 1,
			title: "Pré-Natal",
			date: "12/10/23",
			procedure: "Gravidez - W78",
		},
		{
			id: 2,
			title: "Pré-Natal",
			date: "23/10/23",
			procedure: "Curativo - W78",
		},
	];

	const pregnancyMock = [
		{
			id: 1,
			title: "20 semanas",
			description: "Gestação Normal",
		},
	];

	useEffect(() => {
		if (patient.id) {
			patientAllergies(patient.id);
		}
	}, [patient]);

	return (
		<>
			<CardPatient title="Evolução">
				<div className="gap-2">
					{evolutionMock.map((item, index) => (
						<Fragment key={`evolution-${index}`}>
							<Card.Title className="fs-6 mb-1">
								{item.title} | {item.date}
							</Card.Title>
							<Card.Text>{item.procedure}</Card.Text>
						</Fragment>
					))}
				</div>
			</CardPatient>

			<CardPatient title="Informações da Gestação">
				{pregnancyMock.map((item, index) => (
					<Fragment key={`pregnancy-${index}`}>
						<Card.Title className="fs-6">{item.title}</Card.Title>
						<Card.Text>{item.description}</Card.Text>
					</Fragment>
				))}
			</CardPatient>

			<CardPatient title="Alergias / Reações Adversas">
				{allergies.length ? (
					allergies.map((allergy, index) => (
						<Card.Text key={`allergy-${index}`}>{allergy.description}</Card.Text>
					))
				) : (
					<Card.Text>Sem alergia</Card.Text>
				)}
			</CardPatient>
		</>
	);
}
